(ns teamoesterreich.admin-mode.detail-filter.education-filter
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h] ;;(h/event-value e)
            [teamoesterreich.admin-mode.static-data :as staticData]
            [teamoesterreich.util.log :as log]))



(defn wait-do [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" @!waiting?)
      (when @!waiting? (js/clearTimeout @!waiting?))
      (reset! !waiting?
              (js/setTimeout
                (fn []
                  (event-fn val)
                  (reset! !waiting? false)
                  (reset! !loaded? false))
                500)))))

(defn wait-do-select [!waiting? !loaded? event-fn]
  (fn [e]
    (let [val (h/event-value e)]
      (js/console.log "wait or do" val)
      (event-fn val)
      (reset! !waiting? false)
      (reset! !loaded? false))))


(defn education-block [!detail-search !waiting? !loaded?]
  [mui/grid
   {:item true
    :xs 12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container true
      :direction "row"
      :alignItems "flex-start"
      :justify "flex-start"
      :spacing 1
      :style {:padding "5px"}
      }

     [mui/grid
      {:item true
       :lg 2
       :md 3
       :xs 6
       }
      [mui/typography "Ausbildung"]
      ]


     [mui/grid
      {:item true
       :lg 3
       :md 6
       :sm 8
       :xs 12
       }

      [mui/form-control
       {
        :fullWidth true
        }
       [mui/input-label "Studium"]
       [mui/select
        {:multiple true
         :value (or (get-in @!detail-search [:filter-degree]) [])
         :onChange (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-degree val)))

         }

        (for [[key val] staticData/DEGREES]
          [mui/menu-item {:key (str "deg_" key) :value key } val])

        ]]]
     [mui/grid
      {:item true
       :lg 3
       :md 6
       :sm 8
       :xs 12
       }

      [mui/form-control
       {
        :fullWidth true
        }
       [mui/input-label "Berufsstand"]
       [mui/select
        {:multiple true
         :value (or (get-in @!detail-search [:filter-job-status]) [])
         :onChange (wait-do-select !waiting? !loaded? (fn [val] (swap! !detail-search assoc :filter-job-status val)))
         }
        (for [[iso nat] staticData/JOB-STATUS]
          [mui/menu-item {:key (str "jobstatus_" iso) :value iso } nat])

        ]]]


     ]]])